import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3134b81a")

_pushScopeId("data-v-3134b81a")
const _hoisted_1 = { class: "feed-back" }
const _hoisted_2 = {
  key: 0,
  class: "feed-back__modal"
}
const _hoisted_3 = { class: "feed-back__content" }
const _hoisted_4 = { class: "feed-back__title" }
const _hoisted_5 = { class: "feed-back__text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("a", { href: "mailto:kazakhtourism.feedback@gmail.com" }, " kazakhtourism.feedback@gmail.com", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "btn feed-back__open",
      onClick: _cache[1] || (_cache[1] = $event => ($setup.isOpen = true))
    }, [
      _createVNode(_component_svg_icon, { name: "chat-open" })
    ]),
    ($setup.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", {
            class: "feed-back__overlay",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.isOpen = false))
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode("button", {
              class: "btn feed-back__close",
              onClick: _cache[3] || (_cache[3] = $event => ($setup.isOpen = false))
            }, [
              _createVNode(_component_svg_icon, { name: "close" })
            ]),
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('labels.feedback')), 1),
            _createVNode("div", _hoisted_5, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('labels.feedbackText')), 1),
              _hoisted_6
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})